import { useState } from 'react';
import { HelpOutline, Info } from '@mui/icons-material';
import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HowToUseBankConnection } from './HowToUseBankConnection';

export const HowToUseBankConnectionInfoButton = () => {
  const { t } = useTranslation('bank-connection');
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      <IconButton color={'info'} onClick={open}>
        <HelpOutline />
      </IconButton>
      <Dialog open={isOpen} onClose={close}>
        <DialogContent>
          <HowToUseBankConnection />
        </DialogContent>
        <DialogActions>
          <Button onClick={close} fullWidth>
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
